// A ranked 2v2 party (services: DoublesParty_Domain): { id, ladder_id, status,
// leader, partner, search_id }, where each member is { id, username,
// display_name }. Only invited and ready parties are live; declined and ended
// mean there is no party.

export const INVITED = 'invited';
export const READY = 'ready';
export const DECLINED = 'declined';
export const ENDED = 'ended';

export const isLiveParty = (party) => !!party && (party.status === INVITED || party.status === READY);

export const isPartyLeader = (party, playerId) => !!party && party.leader.id === playerId;

// The member who isn't the player.
export const otherPartyMember = (party, playerId) => (isPartyLeader(party, playerId) ? party.partner : party.leader);

export const memberName = (member) => member.display_name || member.username;
